import { Outlet } from "react-router";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { useUser } from "@/modules/auth/hooks/use-user";
import {
  BulkActionsPanel,
  BulkActionsProvider,
  DETAIL_ROUTE_BY_TYPE,
} from "@/modules/bulk-actions";
import { Header } from "@/modules/layout/components/header";
import { useBulkActionHandlers } from "@/modules/layout/hooks/use-bulk-action-handlers";

import { UpdateChecker } from "./update-checker";

const MainLayout = () => {
  const { user } = useUser();
  const bulkActionHandlers = useBulkActionHandlers();

  if (!user) {
    return <FullScreenLoader />;
  }

  // The tray lives here, not on the screen that triggers a bulk action: a run
  // outlives the list it was started from, and the user is expected to walk into
  // a certificate while it advances. Mounted on the screen it unmounted on the
  // first navigation, and the poll — and the progress with it — stopped.
  return (
    <BulkActionsProvider handlersByType={bulkActionHandlers}>
      <div className="flex min-h-screen w-full flex-col">
        <UpdateChecker />
        <Header />
        <Outlet />
      </div>
      {/* Fixed bottom-right; outside the column so it never affects layout. */}
      <BulkActionsPanel detailRouteByType={DETAIL_ROUTE_BY_TYPE} />
    </BulkActionsProvider>
  );
};

export { MainLayout };
